import axios from '@/utilities/api/axios';

export const state = initialState();

export const actions = {
  getNotifications: async ({ commit }) => {
    try {
      const res = await axios.get(`/notices`);

      commit('mutateNotifications', res.data);
      return res;
    } catch (error) {
      console.error(error);
      return error.response;
    }
  },

  getNotificationCount: async ({ commit }, payload) => {
    try {
      const res = await axios.get(`/notices/count`, {
        params: { ...payload }
      });

      commit('mutateNotificationCount', res.data);

      return res;
    } catch (error) {
      console.error(error);
      return error.response;
    }
  },

  updateNotificationReadStatus: async (_, payload) => {
    try {
      const { noticeId, ...body } = payload;

      const res = await axios.put(
        `/notices/${noticeId}`,
        body
      );

      return res;
    } catch (error) {
      console.error(error);
      return error.response;
    }
  }
};

export const mutations = {
  mutateNotifications: (state, payload) => {
    state.notifications = payload;
  },

  mutateNotificationCount: (state, payload) => {
    state.notificationCount = payload;
  }
};

export const getters = {};

function initialState() {
  return {
    notifications: [],
    notificationCount: ''
  };
}
